interface NameLabelListField {
  enum: {
    name: string;
    value: string;
    label: string;
  }[];
}

export default function mapScEnumToMap<T extends string>(data: NameLabelListField) {
  const resultMap = new Map<T | undefined, string>();

  for (const item of data.enum) {
    resultMap.set(item.name as T, item.label);
  }
  return resultMap;
}
